export default "__VITE_ASSET__DNq$hJmS__"